import rioneMontiBedroom from '@/assets/rione-monti-bedroom-main.webp';
import rioneMontiBathroom from '@/assets/rione-monti-bathroom.png';
import rioneMontiKitchen from '@/assets/rione-monti-kitchen.png';
import rioneMontiBedroom2 from '@/assets/rione-monti-bedroom-2.png';
import rioneMontiBedroom3 from '@/assets/rione-monti-bedroom-3.png';
import rioneMontiBedroomAlt from '@/assets/rione-monti-bedroom.png';
import rioneMontiBuilding from '@/assets/rione-monti-building.png';
import rioneMontiEntrance from '@/assets/rione-monti-entrance.png';
import rioneMontiStairs from '@/assets/rione-monti-stairs.png';
import rioneMontiFoyer from '@/assets/rione-monti-foyer.png';

import dimoraCoronariBedroom from '@/assets/dimora-coronari-bedroom-main.png';
import dimoraCoronariBedroom2 from '@/assets/dimora-coronari-bedroom-2.png';
import dimoraCoronariLiving from '@/assets/dimora-coronari-living.webp';
import dimoraCoronariLiving2 from '@/assets/dimora-coronari-living-2.png';
import dimoraCoronariDining from '@/assets/dimora-coronari-dining.png';
import dimoraCoronariKitchen from '@/assets/dimora-coronari-kitchen.png';
import dimoraCoronariBathroom from '@/assets/dimora-coronari-bathroom.png';
import dimoraCoronariFoyer from '@/assets/dimora-coronari-foyer.png';
import dimoraCoronariEntrance from '@/assets/dimora-coronari-entrance.png';
import dimoraCoronariBuilding from '@/assets/dimora-coronari-building.png';

import suiteTrastevereLiving from '@/assets/suite-trastevere-living.png';
import suiteTrastevereLiving2 from '@/assets/suite-trastevere-living-2.png';
import suiteTrastevereBedroom from '@/assets/suite-trastevere-bedroom.png';
import suiteTrastevereBedroom2 from '@/assets/suite-trastevere-bedroom-2.webp';
import suiteTrastevereBedroom3 from '@/assets/suite-trastevere-bedroom-3.png';
import suiteTrastevereBathroom from '@/assets/suite-trastevere-bathroom.png';
import suiteTrastevereTerrace from '@/assets/suite-trastevere-terrace.png';
import suiteTrasteveBuilding from '@/assets/suite-trastevere-building.png';
import suiteTrasteveEntrance from '@/assets/suite-trastevere-entrance.png';
import suiteTrasteveRestaurants from '@/assets/suite-trastevere-restaurants.png';

import suiteTerminiBedroom from '@/assets/suite-termini-bedroom.jpg';
import suiteTerminiBedroomDetail from '@/assets/suite-termini-bedroom-detail.jpg';
import suiteTerminiLounge from '@/assets/suite-termini-lounge.jpg';
import suiteTerminiBar from '@/assets/suite-termini-bar.jpg';
import suiteTerminiKitchen from '@/assets/suite-termini-kitchen.jpg';
import suiteTerminiKitchenWide from '@/assets/suite-termini-kitchen-wide.jpg';
import suiteTerminiKitchenFridge from '@/assets/suite-termini-kitchen-fridge.jpg';
import suiteTerminiKitchenSink from '@/assets/suite-termini-kitchen-sink.jpg';
import suiteTerminiBathroom from '@/assets/suite-termini-bathroom.png';

export interface Apartment {
  id: string;
  name: string;
  bedrooms: string;
  bathrooms: number;
  guests: string;
  rating?: number;
  reviewCount?: number;
  bookingRating?: number;
  bookingReviewCount?: number;
  airbnbUrl: string;
  bookingUrl: string;
  image: string;
  gallery?: string[];
}

export const apartments: Apartment[] = [
  {
    id: 'rione-monti',
    name: 'Rione Monti Suite',
    bedrooms: '1',
    bathrooms: 1,
    guests: '2',
    rating: undefined,
    reviewCount: undefined,
    bookingRating: 9.0,
    bookingReviewCount: 119,
    airbnbUrl: 'https://airbnb.com/h/rionemontisuite',
    bookingUrl: 'https://www.booking.com/Share-Zh9VmX',
    image: rioneMontiBedroom,
    gallery: [
      rioneMontiBedroom,
      rioneMontiBedroom2,
      rioneMontiBedroom3,
      rioneMontiBedroomAlt,
      rioneMontiKitchen,
      rioneMontiBathroom,
      rioneMontiFoyer,
      rioneMontiEntrance,
      rioneMontiBuilding,
      rioneMontiStairs,
    ],
  },
  {
    id: 'dimora-coronari',
    name: 'Dimora Coronari',
    bedrooms: '2 (3 beds)',
    bathrooms: 1,
    guests: '4',
    rating: 4.91,
    reviewCount: 161,
    bookingRating: 9.3,
    bookingReviewCount: 15,
    airbnbUrl: 'https://airbnb.com/h/dimoracoronari',
    bookingUrl: 'https://www.booking.com/Share-DoVK4e',
    image: dimoraCoronariLiving,
    gallery: [
      dimoraCoronariLiving,
      dimoraCoronariLiving2,
      dimoraCoronariDining,
      dimoraCoronariBedroom,
      dimoraCoronariBedroom2,
      dimoraCoronariKitchen,
      dimoraCoronariBathroom,
      dimoraCoronariFoyer,
      dimoraCoronariEntrance,
      dimoraCoronariBuilding,
    ],
  },
  {
    id: 'suite-trastevere',
    name: 'Suite Trastévere',
    bedrooms: 'Studio + 1',
    bathrooms: 1,
    guests: '2+2 (sofa bed)',
    rating: 4.6,
    reviewCount: 30,
    bookingRating: 9.5,
    bookingReviewCount: 13,
    airbnbUrl: 'https://airbnb.com/h/stylishsuiteneartrastevereandcitylife',
    bookingUrl: 'https://www.booking.com/Share-1BEveW',
    image: suiteTrastevereBedroom2,
    gallery: [
      suiteTrastevereBedroom2,
      suiteTrastevereLiving,
      suiteTrastevereLiving2,
      suiteTrastevereBedroom,
      suiteTrastevereBedroom3,
      suiteTrastevereBathroom,
      suiteTrastevereTerrace,
      suiteTrasteveBuilding,
      suiteTrasteveEntrance,
      suiteTrasteveRestaurants,
    ],
  },
  {
    id: 'suite-termini',
    name: 'Suite Termini',
    bedrooms: 'Studio + 1',
    bathrooms: 1,
    guests: '2',
    bookingRating: 8.8,
    bookingReviewCount: 26,
    airbnbUrl: 'https://airbnb.com/h/terminisuiteroma',
    bookingUrl: 'https://www.booking.com/Share-LMdrr2',
    image: suiteTerminiBedroom,
    gallery: [
      suiteTerminiBedroom,
      suiteTerminiBedroomDetail,
      suiteTerminiLounge,
      suiteTerminiBar,
      suiteTerminiKitchen,
      suiteTerminiKitchenWide,
      suiteTerminiKitchenSink,
      suiteTerminiKitchenFridge,
      suiteTerminiBathroom,
    ],
  },
];

export const testimonials = [
  { name: 'Sarah M.', country: 'United States', rating: 5, text: 'Absolutely stunning apartment! The location near Piazza Navona was perfect. Every detail was thoughtfully designed. Will definitely return!', apartment: 'Dimora Coronari' },
  { name: 'Marco B.', country: 'Germany', rating: 5, text: 'Ein wunderbares Erlebnis! The Monti Suite was elegant and so close to the Colosseum. The hosts were incredibly helpful.', apartment: 'Rione Monti Suite' },
  { name: 'Yuki T.', country: 'Japan', rating: 5, text: 'Perfect blend of modern comfort and Roman charm. The neighborhood restaurants were fantastic. Highly recommend!', apartment: 'Suite Trastévere' },
  { name: 'Elena R.', country: 'Spain', rating: 5, text: 'Increíble ubicación y un apartamento precioso. Los mercados cercanos y la cercanía al Coliseo hicieron nuestra estancia perfecta.', apartment: 'Suite Termini' },
  { name: 'Pierre L.', country: 'France', rating: 5, text: 'Un séjour merveilleux dans un appartement élégant. La Piazza Navona à deux pas, que demander de plus?', apartment: 'Dimora Coronari' },
];
